module.exports = __webpack_public_path__ + "img/success_a.ebda56ad.gif";